// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceProfile__container-c33f2e {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: auto;
  --space-profile-padding: 16px;
}

.SpaceProfile__menu-item-a35b1b {
  min-height: 48px;
  padding: 0 var(--space-profile-padding);
}

.SpaceProfile__menu-item-icon-ff18ec {
  fill: var(--base-80);
}

.SpaceProfile__switcher-b284ce {
  margin-inline-start: auto;
}

.SpaceProfile__close-c22a5a {
  position: absolute;
  top: 20px;
  inset-inline-end: 20px;
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/SpaceProfile/SpaceProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EAEA,6BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,uCAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: auto;\n\n  --space-profile-padding: 16px;\n}\n\n.menu-item {\n  min-height: 48px;\n  padding: 0 var(--space-profile-padding);\n}\n\n.menu-item-icon {\n  fill: var(--base-80);\n}\n\n.switcher {\n  margin-inline-start: auto;\n}\n\n.close {\n  position: absolute;\n  top: 20px;\n  inset-inline-end: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpaceProfile__container-c33f2e`,
	"menu-item": `SpaceProfile__menu-item-a35b1b`,
	"menuItem": `SpaceProfile__menu-item-a35b1b`,
	"menu-item-icon": `SpaceProfile__menu-item-icon-ff18ec`,
	"menuItemIcon": `SpaceProfile__menu-item-icon-ff18ec`,
	"switcher": `SpaceProfile__switcher-b284ce`,
	"close": `SpaceProfile__close-c22a5a`
};
module.exports = ___CSS_LOADER_EXPORT___;
